import type { PostInternalTasksCommentsData } from '@app/api/routes/internalTasks/types'

export const DEFAULT_VALUES_FORM: Omit<PostInternalTasksCommentsData, 'taskId'> = {
  message: ''
}
